import { RemoteLoadFormList } from '@/javascript/data/usecases'
import { LoadFormList } from '@/javascript/domain/usecases'
import { makeCurrentAccountHttpClientDecorator } from '@/javascript/main/factories/decorators'
import {  makeApiUrl } from '../http'

export const makeRemoteLoadFormList = (): LoadFormList =>
  new RemoteLoadFormList(makeApiUrl('/forms'), makeCurrentAccountHttpClientDecorator())